<div class="loader-overlay" role="status" [attr.aria-label]="text">
	<div class="loader-card">
		<div *ngIf="variant === 'sweep'" class="machine">
			<img src="/assets/toolroom-loader.png" alt="" />
			<span class="sweep"></span>
		</div>
		<!-- The SVG animates itself, drawing each line from left to right. -->
		<div *ngIf="variant === 'draw'" class="machine machine-draw">
			<img src="/assets/toolroom-loader-draw.svg" alt="" />
		</div>
		<div class="caption">{{ text }}<span class="dots"><i>.</i><i>.</i><i>.</i></span></div>
	</div>
</div>
